var _defs, _rect, _rect2, _path, _path2, _rect3, _rect4, _line, _line2, _line3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingIndiekrate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-6{fill:none;stroke:#000;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#radial-gradient-3);}.cls-6{stroke-opacity:0.38;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -304.02,
    cy: 295.96,
    r: 1,
    gradientTransform: "matrix(0, 18.1, 14.73, 0, -4258.92, 5558.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff4907",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc642d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -304.02,
    cy: 295.96,
    r: 1,
    gradientTransform: "matrix(0, 18.1, 14.73, 0, -4324.92, 5557.99)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -306.68,
    cy: 285.03,
    r: 1,
    gradientTransform: "matrix(0, 28, 31, 0, -8769, 8685)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc642d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc642d",
    stopOpacity: 0.78
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.06,
    y: 7.18,
    width: 130,
    height: 119,
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.56,
    y: 7.68,
    width: 129,
    height: 118,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.86,112.92l26.06,11.7-25.63,16.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.34,39.11,7.77,27.83,38.57,8.48Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.06,
    y: 25.18,
    width: 130,
    height: 119,
    rx: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.56,
    y: 25.68,
    width: 129,
    height: 118,
    rx: 7.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.81,
    y1: 27.75,
    x2: 160.81,
    y2: 10.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130.79,
    y1: 142.34,
    x2: 160.79,
    y2: 122.76
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.8,
    y1: 27.76,
    x2: 35.8,
    y2: 9.76
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 102.05,
    cy: 55.35,
    rx: 14.74,
    ry: 18.1,
    transform: "translate(-0.95 1.79) rotate(-1)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 102.05,
    cy: 76.35,
    rx: 14.74,
    ry: 18.1,
    transform: "translate(-1.32 1.79) rotate(-1)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 36.05,
    cy: 55.24,
    rx: 14.74,
    ry: 18.1,
    transform: "translate(-0.96 0.64) rotate(-1)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.05,
    cy: 79.35,
    rx: 14.74,
    ry: 18.1,
    transform: "matrix(1, -0.02, 0.02, 1, -1.38, 0.64)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.05,
    cy: 76.35,
    rx: 14.74,
    ry: 18.1,
    transform: "translate(-1.33 0.64) rotate(-1)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 67,
    cy: 98,
    rx: 31,
    ry: 28
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.5,98c0,15.14-13.61,27.5-30.5,27.5S36.5,113.14,36.5,98,50.11,70.5,67,70.5,97.5,82.86,97.5,98Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndiekrate);
export default __webpack_public_path__ + "static/media/loadingIndiekrate.ef58f7af.svg";
export { ForwardRef as ReactComponent };